import { transport } from 'config/transport';

export function callApiExportAbsences(date) {
    return transport.get(`/mamnon/absences/export`, { params: { date }, responseType: 'blob' });
}
